import { consultationStatus, useConsultation } from '@entities/consultations';

export const useConsultationMessage = (id: number) => {
	const { consultation } = useConsultation(id);

	const status = consultationStatus(consultation);

	const getMessage = () => {
		if (!consultation) return;

		if (status === 'notPayed') {
			const link = `${window.location.origin}/consultations/consultations/consultation/${id}`;
			return {
				html: `<p>Для подтверждения консультации, Вам необходимо оплатить</p>
				<p>Ссылка на консультацию:</p>
				<a href="${link}" target="_blank" rel="noreferrer">👉 ${link}</a>`,
				text: `Для подтверждения консультации, Вам необходимо оплатить \n Ссылка на консультацию: 👉 ${link}`,
			};
		}
	};

	return {
		message: getMessage(),
	};
};
